import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import SchemaProps from "./SchemaProps.interface";

const Schema: FunctionComponent<SchemaProps> = (props): JSX.Element => {
    const [data, setData] = useState<object | undefined>(undefined);

    useEffect(() => {
        const result = {
            "@context": "https://schema.org/",
            "@type": "Recipe"
        };

        if (props.recipeName) {
            result["name"] = props.recipeName;
        }
        
        if (props.image) {
            result["image"] = [props.image];
        }
        
        if (props.author) {
            result["author"] = {
                "@type": "Person",
                "name": `${props.author}`
            };
        }

        if (props.datePublished) {
            result["datePublished"] = props.datePublished; // "YYYY-MM-DD"
        }

        if (props.description) {
            result["description"] = props.description;
        }

        if (props.keywords) {
            result["keywords"] = props.keywords;
        }

        if (props.category) {
            result["recipeCategory"] = props.category;
        }

        if (props.cuisine) {
            result["recipeCuisine"] = props.cuisine;
        }

        if (props.ingredients) {
            result["recipeIngredient"] = props.ingredients;
        }

        if (props.steps) {
            result["recipeInstructions"] = props.steps.map((step: string) => {
                return {
                    "@type": "HowToStep",
                    "text": step
                }
            });
        }

        setData(result);
    }, [props]);

    return (
        <Fragment>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}></script>
        </Fragment>
    );
};

export default Schema;